import PropTypes from 'prop-types';
import React from 'react';
/* COMPONENTS */
import { GroupCondensedPropShape } from '../../Includes/GroupPropsShape';
import JoinedGroup from '../JoinedGroup/JoinedGroup';
import RecommendedGroup from '../RecommendedGroup/RecommendedGroup';

export default class RenderGroup extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * object of group
         */
        group: PropTypes.shape({
            ...GroupCondensedPropShape,
            /**
             * string of invite question for user to answer
             */
            inviteQuestion: PropTypes.string,
            /**
             * object of user's relation to group
             */
            userRelation: PropTypes.shape({
                /**
                 * enum of role
                 */
                role: PropTypes.oneOf([
                    'owner',
                    'admin',
                    'moderator',
                    'member',
                    'invited',
                    null,
                ]),
            }),
        }).isRequired,
        /**
         * number of index used as each component's key
         */
        index: PropTypes.number.isRequired,
    };

    render() {
        const { group, index } = this.props;
        const { userRelation } = group;
        const { role } = userRelation;
        const hasRequestedOrInvited =
            role === 'requested' || role === 'invited';

        if (role && !hasRequestedOrInvited) {
            return (
                <JoinedGroup
                    key={`joined-group-${index}`}
                    joinedGroup={group}
                    userRelation={userRelation}
                    shouldShowCtaButtons={false}
                />
            );
        }

        return (
            <RecommendedGroup
                key={`recommended-group-${index}`}
                recommendedGroup={group}
                userRelation={userRelation}
            />
        );
    }
}
